<template>
  <div>Favorite</div>
</template>

<script>
export default {
  name: "QRcode"
};
</script>

<style scoped>

</style>
